module.exports = __webpack_public_path__ + "static/Writers-Print (2)-4529bc32ff14e2f15abb6de8d76ff23d.png";